<template>
    <div class="relative " :cn="componentName">
        <div class="">
            <div class="flex flex-row justify-between w-full">
                <div class="gap-2 static">
                    <CustomButton v-if="this.columns_list" predefinedStlye="default"
                        @button:click="showMenu = !showMenu">
                        <template #label>
                            <i class="fas fa-gears">
                            </i>
                        </template>
                    </CustomButton>

                    <DropdownMenu class="absolute" v-if="showMenu && this.columns_list"
                        @menu:hidesearch="hideSearch = !hideSearch" @menu:menuedit="layoutEdit = !layoutEdit"
                        @menu:save="this.tablePreference.updateCurrent(this.columns_list, this.preference_new_name); this.layoutEdit = false; showMenu = false;"
                        @menu:savenew="this.tablePreference.saveNew(this.columns_list, this.preference_new_name); this.layoutEdit = false; showMenu = false;"
                        @menu:remove="this.tablePreference.delete(this.columns_list); searchPreferences = ''"
                        :open="true" :data="{}" :menuOptions="PreferenceMenuOptions">

                    </DropdownMenu>
                    <custom-button class="ml-4" :loading="isExporting" v-if="exportable" title="Export"
                        @button:click="this.$emit('table:export')">
                        <template #label>
                            <i class="fas fa-file-excel"></i>
                        </template>
                    </custom-button>
                </div>
                <slot name="post-buttons">

                </slot>
                <div v-if="layoutEdit">
                    <TextInput v-model:value="preference_new_name"
                        @input="this.tablePreference.changed[this.columns_list] = true">
                        <template #label>
                            Name
                        </template>
                    </TextInput>
                    <div class="flex flex-row flex-nowrap">
                        <input type="checkbox" v-model="preference_global">
                        {{ __('labels.standard_table.global_preferences') }}
                    </div>

                </div>
                <div v-if="this.columns_list">
                    <div class="flex flex-row flex-nowrap">
                        <DropdownSearchMenu :options="{
                            inputIcon: 'fas fa-coins',
                            placeholder: __('labels.standard_table.search'),
                            title_clear: 'Clear',
                        }" :keys="['name', 'users.name']" :selectkeys="['name']" v-model:search="searchPreferences"
                            :selected="this.tablePreference.use[this.columns_list]" :values="possiblePreferences"
                            @update:search="searchPreferences = $event" :selectElementOnUnfocus="false"
                            @dropdown:select="selectPreferences($event)" @dropdown:clear="clearSelectPreferences()"
                            @menu:loadmore="">

                        </DropdownSearchMenu>
                    </div>
                </div>
            </div>
            <div class="absolute top-0" v-if="copyToClipboard">
                <CustomButton @button:click="copyTableToClipboad()" predefinedStyle="defaultTiny" title="Copy to Clipboad">
                    <template #label>
                        <i class="fas fa-clipboard p-1"></i>
                    </template>

                </CustomButton>

            </div>
            <table ref="standardtable" v-bind:class="[predefinedStyleTable, ...additionalTableClass]" :cn="componentName + '_table'">
                <thead v-bind:class="predefinedStyleThead">
                    <draggable :disabled="isDraggableColumnHeader"
                     @change="columnsChanged" tag="tr" group="header" class="dragArea" :list="useColumns" item-key="id" v-bind:class="predefinedStyleTh">
                     <template #header>


                        <th  slot="header" v-bind:class="predefinedStyleTh" v-if="showRowNr">{{ __('labels.basics.row') }}</th>
                        <th  slot="header" v-bind:class="predefinedStyleTh" v-if="isExtendable"></th>
                        <th  slot="header" v-bind:class="predefinedStyleTh" v-if="isCheckable">
                        </th>
                        <th v-bind:class="predefinedStyleTh" v-if="isCheckableVTwo">
                            <div class="flex flex-col">
                                <div class="flex flex-row gap-2">
                                    <CustomButton :title="__('labels.standard_table.select_title')"
                                        predefinedStyle="defaultTiny" @button:click="selectPage()">
                                        <template #label>
                                            <div class="justify-between px-1">
                                                <i class="fas fa-check"></i>
                                            </div>
                                        </template>
                                    </CustomButton>
                                    <CustomButton v-if="isAllSelectable"
                                        :title="__('labels.standard_table.select_title')" predefinedStyle="defaultTiny"
                                        @button:click="selectAll()">
                                        <template #label>
                                            <div class="justify-between px-1">
                                                <i class="fas fa-check-double"></i>
                                            </div>
                                        </template>
                                    </CustomButton>
                                </div>
                                <div v-if="this.isSelected.length > 0">
                                    <CustomButton :title="__('labels.standard_table.clear_title')"
                                        predefinedStyle="transparentSmallBordered"
                                        @button:click="$emit('table:clearselect')">
                                        <template #label>
                                            <div>
                                                <i class="far fa-times-circle"></i>
                                                <div v-if="this.isSelected.length > 0">
                                                    {{ this.isSelected.length }}
                                                </div>
                                            </div>
                                        </template>
                                    </CustomButton>
                                </div>
                            </div>
                        </th>
                    </template>
                            <template #item="{element, index}">
                                <th v-bind:class="predefinedStyleTh" class="cursor-grab" :key="(columns_list ?? 'table') + '_' + (element.id ?? element.key)">
                            <div class="flex whitespace-nowrap">
                                <div v-if="this.columns_list">

                                    <CustomButton v-if="layoutEdit"
                                        @button:click="adderColumn = (adderColumn == index) ? null : index"
                                        predefinedStyle="transparentSmallBordered">
                                        <template #label>
                                            <i class="fas fa-plus"></i>
                                        </template>
                                    </CustomButton>
                                    <DropdownMenu v-show="adderColumn == index"
                                        @menu:add="this.tablePreference.addColumnPos(this.columns_list, index, $event); adderColumn = null;"
                                        class="absolute " :data="{ none: 'none' }" :menuOptions="unusedColumns">
                                    </DropdownMenu>
                                </div>
                                <Translation :ident="pretranslate + element.label">
                                </Translation>
                                <div class="ml-2 cursor-pointer" v-if="element.direction"
                                    @click="$emit('table:sort', element)">
                                    <i v-if="element.direction == 'ASC'" class="fas fa-arrow-up"></i>
                                    <i v-if="element.direction == 'DESC'" class="fas fa-arrow-down"></i>
                                </div>

                            </div>
                            <div v-if="layoutEdit" class="justify-between flex flex-row">
                                <CustomButton class="flex flex-auto"
                                    @button:click="this.tablePreference.moveColumn(this.columns_list, element, -1)"
                                    predefinedStyle="transparentSmallBordered">
                                    <template #label>
                                        <i class="fas fa-arrow-left"></i>
                                    </template>
                                </CustomButton>
                                <CustomButton class="flex flex-auto" @button:click="removeColumn(element)"
                                    predefinedStyle="transparentSmallBordered">
                                    <template #label>
                                        <i class="fas fa-trash"></i>
                                    </template>
                                </CustomButton>
                                <CustomButton class="flex flex-auto"
                                    @button:click="tablePreference.moveColumn(this.columns_list, element, +1)"
                                    predefinedStyle="transparentSmallBordered">
                                    <template #label>
                                        <i class="fas fa-arrow-right"></i>
                                    </template>
                                </CustomButton>
                            </div>
                            <div v-if="!layoutEdit && showSearch && ('search' in element || 'search_null' in element)">
                                <div class="flex flex-row flex-nowrap whitespace-nowrap" v-if="'search_null' in element">
                                    <input type="checkbox"
                                        @input="this.tablePreference.changed[this.columns_list] = true; $emit('search')"
                                        v-model="element.search_null"> {{ __('labels.standard_table.empty') }}
                                </div>
                                <template v-if="!element.search_null">

                                    <template v-if="'search' in element && element.search_component">
                                        <component class="z-[1000]" :is="element.search_component" :value="element.search"
                                            :columndata="element"
                                            @update:value="debounceSearchComponent(element, $event)">
                                        </component>
                                    </template>
                                    <template v-if="'search' in element && element.type == 'date'">
                                        <CtkDateTimePicker
                                            :first-day-of-week="user_first_day_of_week"
                                            class="w-full text-base dark:text-white outline-none border-2 border-gray-200 dark:border-transparent dark:hover:border-slate-500
                                    dark:focus-visible:border-slate-500 focus-visible:border-accent-color rounded-md py-1.5 px-3"
                                            :class="{ 'dark:bg-gray-700 bg-white': true }" :no-label="true"
                                            :custom-mount-point-handler="true" :right="true" :range="true"
                                            :no-class="true" :no-clear-button="false" format="YYYY-MM-DD" :formatted="momentDateFormatted"
                                            :no-button="true" :only-date="true" :locale="locale"
                                            @update:model-value="checkForSearchEmit(element)"
                                            @input="element.search = $event" v-model="element.search"
                                            ref="datetimepicker">
                                        </CtkDateTimePicker>
                                    </template>
                                    <template v-if="'search' in element && element.type == 'datetime'">
                                        <CtkDateTimePicker
                                        :first-day-of-week="user_first_day_of_week"
                                            class="w-full text-base dark:text-white outline-none border-2 border-gray-200 dark:border-transparent dark:hover:border-slate-500
                                    dark:focus-visible:border-slate-500 focus-visible:border-accent-color rounded-md py-1.5 px-3"
                                            :class="{ 'dark:bg-gray-700 bg-white': true }" :no-label="true"
                                            :custom-mount-point-handler="true" :right="true" :range="true"
                                            :no-class="true" :no-clear-button="false" format="YYYY-MM-DD" :formatted="momentDateFormatted+' HH:mm:ss'"
                                            :no-button="true"  :locale="locale"
                                            @update:model-value="checkForSearchEmit(element)"
                                            @input="element.search = $event" v-model="element.search"
                                            ref="datetimepicker">
                                        </CtkDateTimePicker>
                                    </template>
                                    <template v-if="'search' in element && element.type != 'date' && element.type != 'datetime' && !element.search_component">
                                        <text-input :value="element.search"
                                            @update:value="element.search = $event; $emit('search'); this.tablePreference.changed[this.columns_list] = true"></text-input>
                                    </template>
                                </template>
                            </div>
                        </th>
                        </template>
                        <template #footer>
                            <th v-bind:class="predefinedStyleTh" v-if="showActionColumn"></th>
                            <th v-if="this.columns_list && this.unusedColumns.length > 0">
                                <CustomButton v-if="layoutEdit" @button:click="adderMenu = !adderMenu"
                                predefinedStyle="transparentSmall">
                                    <template #label>
                                        <i class="fas fa-plus"></i>
                                    </template>
                                </CustomButton>
                                <DropdownMenu v-show="adderMenu" @menu:add="addColumn($event); adderMenu = false;"
                                class="absolute " :data="{ none: 'none' }" :menuOptions="unusedColumns">
                                </DropdownMenu>
                            </th>
                    </template>
                    </draggable>
                </thead>
                <tbody v-bind:class="predefinedStyleTbody">
                    <tr class="bg-gray-100 dark:bg-slate-700 z-0" :key="getUniq()" v-if="isEmpty && !isLoading">
                        <td v-bind:class="predefinedStyleTd" class="text-center" colspan="50">
                            <Translation ident="labels.basics.no_results">

                            </Translation>
                        </td>
                    </tr>
                    <template v-for="(data, index) in dataset" :key="(columns_list ?? 'table') + '_' + data.id">
                        <tr :cn="componentName + '_row_' + index" class="z-0"
                            v-bind:class="[predefinedStyleTr, { 'dark:bg-slate-700': (index % 2 === 0), 'bg-gray-100 dark:bg-slate-800': !(index % 2 === 0) }]">
                            <td :class="{ 'blur-sm z-0': isLoading }" v-if="this.showRowNr"
                                v-bind:class="predefinedStyleTd">
                                {{ index + 1 }}
                            </td>
                            <td :class="{ 'blur-sm z-0': isLoading }" v-if="isExtendable">
                                <CustomButton @button:click="$emit('table:expand', { index, data })">
                                    <template #label>
                                        <i v-if="expanded['expand_' + index] == true" class="fas fa-eye-slash"></i>
                                        <i v-else class="fas fa-eye"></i>
                                    </template>

                                </CustomButton>
                            </td>

                            <td :class="{ 'blur-sm z-0': isLoading }" v-if="this.isCheckable"
                                v-bind:class="predefinedStyleTd">
                                <input v-model="data.selected" type="checkbox">
                            </td>

                            <td :class="{ 'blur-sm z-0': isLoading }" v-if="this.isCheckableVTwo"
                                v-bind:class="predefinedStyleTd">
                                <input :checked="isSelected.includes(data.id)"
                                    @click="checkboxChangeHandler($event, data, index)" :disabled="!data.isCheckable"
                                    type="checkbox">
                            </td>

                            <td :class="{ 'blur-sm z-0': isLoading }"
                                v-bind:class="[predefinedStyleTd, { 'text-right': (column.align == 'right') }]"
                                v-for="(column, index2) in useColumns" :key="data.id + ' ' + index2">
                                <span class="text-red-400" v-if="column.warn_function == 'empty' && lodash.get(data, column.warn_key, null) == null"> 
                                    <i class="fas fa-exclamation-triangle"></i>
                                </span>
                                <a href=""
                                    class=" text-blue-500 hover:text-blue-700 dark:hover:text-blue-100 dark:text-blue-400"
                                    v-if="column.type == 'function' && typeof (column.clickFunction) == 'function'"
                                    @click.prevent="column.clickFunction({ data, index }, this)">
                                    {{ lodash.get(data, column.key) }}
                                </a>
                                <a class="button is-small is-link is-inverted" v-if="column.type == 'link'"
                                    :href="$store.state.settings.url + column.linkadder + lodash.get(data, column.key)">
                                    {{ lodash.get(data, column.key) }}
                                </a>
                                <p v-if="column.component">
                                    <component :is="column.component" :data="lodash.get(data, column.key)" :row="data">
                                    </component>
                                </p>
                                <p v-if="column.html" v-html="lodash.get(data, column.key)"></p>
                                <p v-if="column.directEdit">
                                    <text-input
                                        :predefinedStyle="(this.errors && this.errors[index] && this.errors[index][column.key] == true) ? 'error' : 'default'"
                                        :type="column.type" v-model:value="data[column.key]"></text-input>
                                </p>
                                <p v-if="column.localized">
                                    {{ lodash.get(data, column.key + "." + this.locale, lodash.get(data, column.key +
                                        ".en", "")) }}
                                </p>
                                <p v-if="column.languageLabel">
                                    {{ __('labels.languages.' + lodash.get(data, column.key)) }}
                                </p>
                                <p v-if="column.type == 'language'">
                                    <translation :ident="column.pre_label + lodash.get(data,column.key)"></translation>
                                </p> 
                                <p v-if="typeof column.function == 'function'">
                                    {{ __(column.function(lodash.get(data, column.key))) }}
                                </p>
                                <p v-if="column.type == 'boolean'">
                                    <translation :ident="'labels.boolean.' + lodash.get(data, column.key)">
                                    </translation>
                                </p>
                                <p v-if="column.type == 'select'">
                                    {{ lodash.get(data, column.key) }}
                                </p>
                                <p
                                    v-if="column.type == 'date' && (column.format === undefined || column.format === null)">
                                    {{ __date(lodash.get(data, column.key)) }}
                                </p>
                                <p
                                    v-if="column.type == 'datetime' && (column.format === undefined || column.format === null)">
                                    {{ __datetime(lodash.get(data, column.key)) }}
                                </p>

                                <a class="button is-small is-link is-inverted text-blue-400"
                                    v-if="column.type == 'external_link' && column.link_key"
                                    :href="lodash.get(data, column.link_key)" target="_blank">
                                    {{ lodash.get(data, column.key) }}
                                </a>
                                <template v-if="column.type == 'unread'">
                                    <unread-marker
                                        :unread="(lodash.get(data, column.key) ? false : true)"></unread-marker>
                                </template>
                                <p
                                    v-if="column.type == 'date' && (column.format !== undefined && column.format !== null)">
                                    {{ __date(lodash.get(data, column.key), column.format) }}
                                </p>
                                <p
                                    v-if="column.type == 'datetime' && (column.format !== undefined && column.format !== null)">
                                    {{ __datetime(lodash.get(data, column.key), column.format) }}
                                </p>
                                <p
                                    v-if="column.type == 'decimal' && (column.digits === undefined || column.digits === null)">
                                    {{ __decimal(lodash.get(data, column.key)) }} <template v-if="lodash.get(data, column.key) && 'append' in column"> {{ (!column.append?.value) ? lodash.get(data, column.append.key) : column.append.value }} </template>
                                </p>
                                <p
                                    v-if="column.type == 'decimal' && (column.digits !== undefined && column.digits !== null)">
                                    {{ __decimal(lodash.get(data, column.key), column.digits) }} <template v-if=" lodash.get(data, column.key) && 'append' in column"> {{ (!column.append?.value) ? lodash.get(data, column.append.key) : column.append.value }} </template>
                                </p>

                                <p v-if="column.displayType == 'popover'">
                                    <Popover :content="lodash.get(data, column.key)" />
                                </p>
                                <p v-if="column.type && column.type.indexOf('string_shorten_') === 0"
                                    :title="lodash.get(data, column.key)">
                                    <template v-if="column.link">
                                        <ErrorBoundry>
                                            <template #try>
                                                <router-link class="is-link text-blue-500" :to="{
                                                    name: column.link.to,
                                                    params: prepareLinkParams(data, column.link?.params ?? null)
                                                }">
                                                    {{ lodash.truncate(lodash.get(data, column.key), {
                                                        length: parseInt(column.type.substr(15)),
                                                        separator: " ",
                                                        ommission: ' ...'
                                                    }) }}
                                                </router-link>
                                            </template>
                                            <template #catch>
                                                {{ lodash.truncate(lodash.get(data, column.key), {
                                                length: parseInt(column.type.substr(15)),
                                                separator: " ",
                                                ommission: ' ...'
                                                }) }}
                                            </template>
                                    </ErrorBoundry>
                                    </template>
                                    <template v-else>
                                        {{ lodash.truncate(lodash.get(data, column.key), {
                                            length: parseInt(column.type.substr(15)),
                                            separator: " ",
                                            ommission: ' ...'
                                        }) }}
                                    </template>

                                </p>
                                <p v-if="!column.localized && (typeof column.function != 'function') &&
                                    (column.type != 'function') &&
                                    (column.html == undefined || !column.html) &&
                                    (column.directEdit == undefined || !column.directEdit) &&
                                    (column.languageLabel == undefined || !column.languageLabel) &&
                                    (column.type == undefined || !column.type) &&
                                    (column.displayType == undefined || !column.displayType) &&
                                    (!column.component)
                                ">
                                    <template v-if="column.link">
                                        <ErrorBoundry>
                                            <template #try>
                                                <router-link class="is-link text-blue-500" :to="{
                                                    name: column.link.to,
                                                    params: prepareLinkParams(data, column.link?.params ?? null)
                                                    }">
                                                    {{ lodash.get(data, column.key) }}
                                                </router-link>
                                            </template>
                                            <template #catch>
                                                {{ lodash.get(data, column.key) }}
                                            </template>
                                        </ErrorBoundry>
                                    </template>
                                    <template v-else>
                                        <span :title="lodash.get(data, column.title_key)">
                                            {{ lodash.get(data, column.key) }}
                                        </span>
                                    </template>
                                </p>
                            </td>

                            <td v-bind:class="predefinedStyleTd" class="whitespace-nowrap text-right"
                                v-if="showActionColumn">
                                <div class="flex flex-row justify-end">
                                    <div
                                        v-if="((typeof (this.isEditable) == 'function') ? this.isEditable(data) : this.isEditable)">
                                        <custom-button predefinedStyle="transparentSmall"
                                            @button:click="$emit('table:edit', { data, index })">
                                            <template v-slot:label>
                                                <span class="icon">
                                                    <i :class="this.editIcon"></i>
                                                </span>
                                            </template>
                                        </custom-button>
                                    </div>

                                    <div
                                        v-if="((typeof (this.isDuplicateable) == 'function') ? this.isDuplicateable(data) : this.isDuplicateable)">
                                        <custom-button predefinedStyle="transparentSmall"
                                            @button:click="$emit('table:duplicate', { data, index })">
                                            <template v-slot:label>
                                                <span class="icon">
                                                    <i class="fas fa-copy"></i>
                                                </span>
                                            </template>
                                        </custom-button>
                                    </div>

                                    <div v-if="this.isDeleteable">
                                        <custom-button v-if="this.isDeleteable" predefinedStyle="transparentSmall"
                                            @button:click="$emit('table:delete', { data, index })">
                                            <template v-slot:label>
                                                <span class="icon">
                                                    <i class="fas fa-trash-alt"></i>
                                                </span>
                                            </template>
                                        </custom-button>
                                    </div>

                                    <div v-if="(menuOptions !== undefined && Object.keys(menuOptions).length > 0)">
                                        <custom-button :ref="'opt' + index" :id="'opt' + index"
                                            predefinedStyle="transparentSmall"
                                            @button:click="openMoreOptions(data, 'opt' + index)">
                                            <template v-slot:label>
                                                <span class="icon">
                                                    <i class="fas fa-ellipsis-h"></i>
                                                </span>
                                            </template>
                                        </custom-button>
                                        <div class="sticky" style="z-index:2000">
                                            <transition name="openmenu">
                                                <dropdown-menu v-if="menuOpen == data.id" class="absolute"
                                                    :class="shiftMenu" :data="data" :menuOptions="myMenuOptions(data)"
                                                    @event:menu="emitFromMenu($event, data)"></dropdown-menu>
                                            </transition>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td v-if="this.columns_list && this.unusedColumns.length > 0">
                                <!-- Row bis zum Ende ziehen wenn das Plus eingeblendet wird -->
                            </td>

                        </tr>
                        <tr v-if="workingOn && workingOn.includes(data[workingOnIdentifier])">
                            <td  class="w-1 static" :colspan="this.columnCount">
                                <div class="animate_moving absolute h-1 w-32 bg-blue-600">

                                </div>
                            </td>
                        </tr>
                        <tr class="w-full" v-if="expanded['expand_' + index] == true">
                            <td :colspan="this.columnCount">
                                <slot :name="'expand_' + index">

                                </slot>
                            </td>
                        </tr>

                    </template>
                    <tr v-if="showPageTotal" :class="{ 'blur-sm z-0': isLoading }">
                        <td :class="predefinedStyleTotalTd" v-if="showRowNr">
                        </td>
                        <td :class="predefinedStyleTotalTd" v-if="isExtendable">
                        </td>
                        <td :class="predefinedStyleTotalTd" v-if="isCheckable || isCheckableVTwo">
                        </td>
                        <template v-if="allow_page_sum" v-for="(column, index2) in useColumns" :key="'totals_ '+ index2">
                            <td v-if="column.type == 'decimal' && (!column.export_function || column.export_function == 'SUM')"
                                v-bind:class="[predefinedStyleTotalTd, { 'text-right': (column.align == 'right') }]">
                                <i class="fas fa-info-circle" :title="__('labels.standard_table.page_sum')"></i>
                                    {{
                                        __decimal(lodash.sumBy(dataset, (o) => { return parseFloat((lodash.get(o, column.key, 0) ?? 0)) }), column.digits ?? 2)
                                    }}
                            </td>
                            <td v-else-if="column.type == 'decimal' && (column.export_function &&  column.export_function == 'calculation' && column.calculation)" :class="[predefinedStyleTotalTd, { 'text-right': (column.align == 'right') }]">
                                <i class="fas fa-info-circle" :title="__('labels.standard_table.page_sum')"></i>
                                {{ __decimal(calculatedSum(column), 2) }}
                            </td>
                            <td v-else-if="column.type == 'decimal' && (column.export_function && column.export_function == 'average_not_null')" :class="[predefinedStyleTotalTd, { 'text-right': (column.align == 'right') }]">
                                <i class="fas fa-info-circle" :title="__('labels.standard_table.page_sum')"></i>
                                ⌀ {{ __decimal(lodash.sumBy(dataset, (o) => { return parseFloat((lodash.get(o, column.key, 0) ?? 0)) }) / dataset.length, column.digits ?? 2) }}
                            </td>
                            <td v-else-if="column.type == 'decimal' && (column.export_function && column.export_function == 'average')" :class="[predefinedStyleTotalTd, { 'text-right': (column.align == 'right') }]">
                                <i class="fas fa-info-circle" :title="__('labels.standard_table.page_sum')"></i>
                                <span v-if="dataset.filter(item => lodash.get(item, column.key, 0)).length > 0">
                                    ⌀ {{ __decimal(lodash.sumBy(dataset.filter(item => lodash.get(item, column.key, 0) != 0 ), (o) => { return parseFloat((lodash.get(o, column.key, 0) ?? 0)) }) / dataset.filter(item => lodash.get(item, column.key, 0)).length, column.digits ?? 2) }}
                                </span>
                                <span v-else>
                                    ⌀ {{ __decimal(0, column.digits ?? 2) }}
                                </span>
                            </td>
                            <td v-else
                            v-bind:class="[predefinedStyleTotalTd, { 'text-right': (column.align == 'right') }]">
                                &nbsp;
                            </td>
                        </template>
                    </tr>
                    <tr v-if="totals != ''" class="pt-4 border-t-8">
                        <td :class="predefinedStyleTotalTd" v-if="showRowNr">
                        </td>
                        <td :class="predefinedStyleTotalTd" v-if="isExtendable">
                        </td>
                        <td :class="predefinedStyleTotalTd" v-if="isCheckable || isCheckableVTwo">
                        </td>
                        <template v-for="(column, index2) in useColumns" :key="'totals_ '+ index2">
                            <td v-if="lodash.get(totals, column.key, '') != ''"
                                v-bind:class="[predefinedStyleTotalTd, { 'text-right': (column.align == 'right') }]"
                                v-html="lodash.get(totals, column.key)">

                            </td>
                            <td v-else :class="[predefinedStyleTotalTd, { 'text-right': (column.align == 'right') }]">
                                &nbsp;
                            </td>
                        </template>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="absolute inset-x-1/2 inset-y-1/4" v-show="isLoading">
            <simple-loading-icon> </simple-loading-icon>
        </div>
    </div>
</template>
<script>
import _ from 'lodash';
import draggable from 'vuedraggable'
import CustomButton from './CustomButton.vue';
import MultiSelect from './MultiSelect.vue';
import CtkDateTimePicker from '@/components2/VueCtkDateTimePicker/VueCtkDateTimePicker/index.vue';
import DropdownSearchAgents from './DropdownSearchAgents.vue';
import DropdownSearchCompanies from './DropdownSearchCompanies.vue';
import DropdownSearchCurrencies from './DropdownSearchCurrencies.vue';
import unreadMarker from './unreadMarker.vue';
import ActionSteps from '@/components/kooi/ActionSteps.vue';
import Popover from './Popover.vue';
import { useTablePreferenceStore } from '../../pinia/TablePreferenceStore';
import { times } from 'lodash';
import DropdownMenu from './DropdownMenu.vue';
import DropdownSearchMenu from './DropdownSearchMenu.vue';
import { add } from 'lodash';
import { findLastIndex } from 'lodash';
import { useCurrentUserStore } from '../../pinia/CurrentUserStore';
import MultiSelectCompanyTypesSearch from './MultiSelectCompanyTypesSearch.vue';
import DropdownMultiSelectByDistinct from './DropdownMultiSelectByDistinct.vue';
import ErrorBoundry from './ErrorBoundry.vue';
import { useLanguageStore } from '../../pinia/LanguageStore';
import Translation from './Translation.vue';
import TextInput from './TextInput.vue';
import { can } from '../permissions-handler/helpers/usePermissions';
import { momentDateFormat } from '@/helpers/useInternalCompany';

export default {
    setup() {
        const tablePreference = useTablePreferenceStore();
        const currentUser = useCurrentUserStore();
        const momentDateFormatted = momentDateFormat();
        return {
            tablePreference,
            currentUser,
            can,
            momentDateFormatted,
        };
    },
    components: {
        Translation,
        TextInput,
        DropdownSearchMenu,
        CustomButton,
        CtkDateTimePicker,
        DropdownSearchAgents,
        DropdownSearchCompanies,
        MultiSelect,
        Popover,
        ActionSteps,
        DropdownMenu,
        DropdownSearchCurrencies,
        unreadMarker,
        MultiSelectCompanyTypesSearch,
        DropdownMultiSelectByDistinct,
        draggable,
        ErrorBoundry,
    },
    props: {
        copyToClipboard: {
            type: Boolean,
            default: false,
        },
        exportable: {
            type: Boolean,
            default: false,
        },
        showPageTotal: {
            type: Boolean,
            default: false,
        },
        isExtendable: {
            type: Boolean,
            default: false,
        },
        expanded: {
            type: Array,
            default: [],
        },
        isExporting: {
            type: Boolean,
            default: false,
        },
        isSearchable: {
            type: Boolean,
            default: false,
        },
        isAllSelectable: {
            type: Boolean,
            default: false,
        },
        "columns_list": {
            type: String,
        },
        "columns": Array,
        "dataset": Array,
        "workingOn": Array,
        "workingOnIdentifier" : {
            type: String,
            default: "id",
        },
        "pretranslate": String,
        "predefinedStyle": String,

        isLoading: { type: Boolean, default: false },
        "isCheckable": Boolean, // deprecated
        isCheckableVTwo: {
            default: false,
        },
        isDraggableColumnHeader: {
            default : false,
        },
        "isEditable": {
            type: [Boolean, Function]
        },
        "isDuplicateable": {
            type: [Boolean, Function]
        },
        "editIcon": {
            type: String,
            default: "fas fa-pencil-alt"
        },
        "isDeleteable": Boolean,
        "menuViaKey": {
            type: [String, Array],
            required: false,
        },
        "menuViaString": String,
        "menuOptions": {
            type: Object,
        },
        shiftMenu: {
            type: Array,
            default: ["-left-64", "md:-left-48", "hd:-left-48"]
        },
        loadMoreButton: {
            type: Boolean,
            default: false,
        },
        errors: {
            type: Array,
            required: false,
        },
        totals: {
            required: false,
            default: ""
        },
        allow_page_sum: {
            default : true,
        },
        showRowNr: {
            type: Boolean,
            default: false,
        },
        isSelected: {
            type: Array,
            default: [],
        },
        additionalTableClass: {
            type: Array,
            default: [],
        }
    },
    data() {
        return {
            searchPreferences: '',
            showMenu: false,
            hideSearch: false,
            adderMenu: false,
            adderColumn: null,
            layoutEdit: false,
            preference_new_name: "",
            preference_id: 0,
            selectedData: [],
            menu: {
                open: false,
            },
            mailMenu: {
                isOpen: false,
            },
            menuOpen: false,
            menuPosition: {
                x: 0,
                y: 0,
            },
            debounce: {
                scroll: null,
                searchComponents: null,
            },
            predefinedStyles: {
                default: {
                    table: "table-auto w-full border-collapse border dark:border-gray-600",
                    thead: "bg-gray-200 dark:bg-slate-800",
                    th: "px-3 py-2.5 text-base border-t dark:border-t-slate-600 border-b dark:border-b-gray-800 text-stone-900 dark:text-slate-100 font-bold text-left",
                    tbody: "",
                    tr: "hover:bg-gray-100 dark:hover:bg-slate-600",
                    td: "px-3 py-1.5 text-base border-t dark:border-t-slate-600 border-b dark:border-b-gray-800 text-stone-900 dark:text-slate-100 font-normal",
                    total_td: "px-3 py-1.5 text-base border-t dark:border-t-slate-600 border-b dark:border-b-gray-800 text-stone-900 dark:text-slate-100 font-normal",
                },
                dashboard: {
                    table: "table-auto w-full border-collapse border dark:border-gray-600",
                    thead: "bg-gray-200 dark:bg-gray-800",
                    th: "px-4 py-2 text-base border-t dark:border-t-gray-800 border-b dark:border-b-gray-800 text-stone-900 dark:text-slate-100 font-medium text-left",
                    tbody: "",
                    tr: "hover:bg-gray-400",
                    td: "px-4 py-2 text-base border-t dark:border-t-gray-800 border-b dark:border-b-gray-800 text-stone-900 dark:text-slate-100 font-normal whitespace-nowrap",
                    total_td: "px-4 py-2 text-base border-t dark:border-t-gray-800 border-b dark:border-b-gray-800 text-stone-900 dark:text-slate-100 font-normal whitespace-nowrap",
                },
                defaultStickyHead: {
                    table: "table-auto inline-block border-collapse border dark:border-gray-600 max-w-full overflow-auto relative max-h-[75vh]",
                    thead: "sticky top-0 bg-gray-200 dark:bg-gray-800",
                    th: "px-4 py-2 text-base border-t dark:border-t-gray-800 border-b dark:border-b-gray-800 text-stone-900 dark:text-slate-100 font-medium text-left",
                    tbody: "max-w-full",
                    tr: "hover:bg-gray-300 dark:hover:bg-gray-500",
                    td: "px-4 py-2 text-base border-t dark:border-t-gray-800 border-b dark:border-b-gray-800 text-stone-900 dark:text-slate-100 font-normal whitespace-nowrap",
                    total_td: "bg-gray-200 dark:bg-gray-800 px-4 py-2 text-base border-t dark:border-t-gray-800 border-b dark:border-b-gray-800 text-stone-900 dark:text-slate-100 font-normal whitespace-nowrap",
                },
                defaultStickyHeadSmall: {
                    table: "table-auto inline-block border-collapse border dark:border-gray-600 max-w-full overflow-auto relative max-h-[500px]",
                    thead: "sticky top-0 bg-gray-200 dark:bg-gray-800",
                    th: "px-4 py-2 text-base border-t dark:border-t-gray-800 border-b dark:border-b-gray-800 text-stone-900 dark:text-slate-100 font-medium text-left",
                    tbody: "max-w-full",
                    tr: "hover:bg-gray-300 dark:hover:bg-gray-500",
                    td: "px-4 py-2 text-base border-t dark:border-t-gray-800 border-b dark:border-b-gray-800 text-stone-900 dark:text-slate-100 font-normal whitespace-nowrap",
                    total_td: "bg-gray-200 dark:bg-gray-800 px-4 py-2 text-base border-t dark:border-t-gray-800 border-b dark:border-b-gray-800 text-stone-900 dark:text-slate-100 font-normal whitespace-nowrap",
                },
            },
            multiselect: {
                start: -1,
                end: -1,
            }
        }
    },
    mounted() {
        window.emitter.on("app:reload", () => {
            if (this.columns_list && this.columns_list.trim() != "") {
                this.tablePreference.clear();
                this.tablePreference.tableIdent(this.columns_list);
            }
        });
        if (this.columns_list && this.columns_list.trim() != "") {
            this.tablePreference.tableIdent(this.columns_list);
            console.log("tablePreference", this.tablePreference);
        }
    },
    watch: {
        columns_list(newVal) {
            if (newVal in this.tablePreference.columns) {

            } else {
                this.tablePreference.tableIdent(newVal);
            }
        }
    },
    methods: {
        debounceSearchComponent(element, event){
            if(this.debounce.searchComponents){
                clearTimeout(this.debounce.searchComponents);
            }
            this.debounce.searchComponents = setTimeout(() => {
                element.search = event; 
                this.tablePreference.changed[this.columns_list] = true; 
                this.$emit('search')
            }, 300)
        },
        emitFromMenu(event, data){
            if(event.data){
                this.emitter.emit(event.emit, {data : data, menuData : event.data })
            }else{
                this.$emit('menu:' + event.key, { childevent: event, data: data });
            }
            this.menuOpen = false
        },
        calculatedSum(column){
            try{

                let calculation = column.calculation.split(" ");
                let values = {};
                for(let i in calculation){
                    if(_.has(this.dataset[0], calculation[i])){
                        values[calculation[i]] = _.sumBy(this.dataset, (o) => { return parseFloat((_.get(o, calculation[i], 0) ?? 0)) })
                        calculation[i] = "{" + calculation[i] + "}"
                    }
                }
                let calculation_string = "";
                for(let i in calculation){
                    calculation_string = calculation_string + calculation[i] + " ";
                }
                return this.executeFormula(this.translateFormula(calculation_string, values));
            }catch(error) {
                console.log(error);
            };
        },
        copyTableToClipboad(){
            const tableHTMLString = this.$refs.standardtable.outerHTML;

            const plainTextString = this.$refs.standardtable.innerText;

            navigator.clipboard.write([
                new ClipboardItem({
                    'text/html': new Blob([tableHTMLString], {
                        type: 'text/html',
                    }),
                    'text/plain': new Blob([plainTextString], {
                        type: 'text/plain',
                    }),
                }),
            ]);
        },
        checkForSearchEmit(column) {
            this.$nextTick(() => {
                if (column.search && !column.search.end) {
                    return;
                }
                this.$emit('search');
                this.tablePreference.changed[this.columns_list] = true
            })
        },
        resetMultiselect() {
            this.multiselect.start = -1;
            this.multiselect.end = -1;
        },
        checkboxChangeHandler(event, data, index) {
            this.emitEventSelect(data);
            if (event.shiftKey) {
                if (this.multiselect.start > -1) {
                    this.multiselect.end = index;
                    if (this.multiselect.end > this.multiselect.start) {
                        var start = this.multiselect.start + 1;
                        var end = this.multiselect.end;
                    } else {
                        var end = this.multiselect.start;
                        var start = this.multiselect.end + 1;
                    }
                    for (let i = start; i < end; i++) {
                        this.emitEventSelect(this.dataset[i]);
                    }
                    this.resetMultiselect();
                }
            }
            this.multiselect.start = index;
        },
        selectPage(value) {
            for (let i in this.dataset) {
                this.emitEventSelect(this.dataset[i]);
            }
        },
        selectAll() {
            this.$emit("table:select_all");
        },
        emitEventSelect(data) {
            if (!'isCheckable' in data || data.isCheckable == true) {
                this.$emit("table:select", { data: data.id });
            }
        },
        myMenuOptions(data) {
            if (Array.isArray(this.menuViaKey)) {
                var tmp = this.menuOptions;
                for (let i in this.menuViaKey) {
                    tmp = tmp[this.lodash.get(data, this.menuViaKey[i])];
                };
                return tmp;
            }
            return this.lodash.get(this.menuOptions, data[this.menuViaKey], this.menuOptions[this.menuViaString]);
        },
        prepareLinkParams(data, params) {
            if (!params || !data) {
                return {};
            }
            var tmp = {};
            for (let i in params) {
                if(params[i].substr(0, 1) == "-"){
                    tmp[i] = params[i].substr(1);
                }else{
                    tmp[i] = this.lodash.get(data, params[i], params[i]);
                }
            }
            return tmp;
        },
        checkRequiredParams(data, params){
            let parameters = this.prepareLinkParams(data, params.params);
            if(params.required && params.required.length > 0){
                for(let i in params.required){
                    console.log("required", params.required[i]);
                    if(!(params.required[i] in parameters)){
                        console.log("return false")
                        return false;
                    }
                }
            }
            return true;
        },
        clearSelectPreferences() {
            this.searchPreferences = ''
            this.preference_new_name = '';
            this.tablePreference.use[this.columns_list] = 0;
            this.tablePreference.changed[this.columns_list] = false;
            this.$emit("search");
        },
        selectPreferences(event) {
            this.searchPreferences = event.name;
            this.preference_new_name = event.name;
            this.tablePreference.use[this.columns_list] = event.id;
            this.tablePreference.changed[this.columns_list] = false;
            this.$emit('search')

        },
        resetMenus() {
            if (this.menu) {

                for (let i in this.menu) {
                    this.menu[i] = false;
                }
            };
        },
        columnsChanged(event){
            if (this.tablePreference.use[this.columns_list] == 0) {
                this.tablePreference.prepareChanges(this.columns_list);
                this.tablePreference.use[this.columns_list] = '+';
                this.preference_id = '+';
            }
            this.tablePreference.changed[this.columns_list] = true;
            this.tablePreference.moveColumn(this.columns_list, event.moved.element, event.moved.newIndex - event.moved.oldIndex )
            this.resetMenus();
        },
        addColumn(event) {
            if (this.tablePreference.use[this.columns_list] == 0) {
                this.tablePreference.prepareChanges(this.columns_list);
                this.tablePreference.use[this.columns_list] = '+';
                this.preference_id = '+';
            }
            this.tablePreference.changed[this.columns_list] = true;
            this.tablePreference.addColumn(this.columns_list, event.data);
            this.resetMenus();
        },
        removeColumn(column) {
            if (this.tablePreference.use[this.columns_list] == 0) {
                this.tablePreference.prepareChanges(this.columns_list);
                this.tablePreference.use[this.columns_list] = '+';
                this.preference_id = '+';
            }
            this.tablePreference.changed[this.columns_list] = true;
            this.tablePreference.removeColumn(this.columns_list, column);
            this.resetMenus();
        },
        openMoreOptions(data, opt) {
            // set position of context menu
            var pos = this.$refs[opt][0]['$el'].getBoundingClientRect();
            this.menuPosition.x = pos.x - 125;
            this.menuPosition.y = pos.y + 35;

            if (data.id == this.menuOpen) {
                this.menuOpen = false;
            } else {
                this.menuOpen = data.id
            }
        },
    },
    computed: {
        isAllChecked() {
            for (let i in this.dataset) {
                return false;
            }
            return true;
        },
        preference_global: {
            get() {
                var index = this.tablePreference.preferences[this.columns_list].findIndex(item => item.id == this.tablePreference.use[this.columns_list]);
                if (index >= 0) {
                    return this.tablePreference.preferences[this.columns_list][index].global;
                }
                return false;
            },
            set(value) {
                var index = this.tablePreference.preferences[this.columns_list].findIndex(item => item.id == this.tablePreference.use[this.columns_list]);
                if (index >= 0) {
                    this.tablePreference.preferences[this.columns_list][index].global = value
                }
            }
        },
        showSearch() {
            return this.isSearchable && !this.hideSearch;
        },
        user() {
            return this.currentUser.user;
        },
        PreferenceMenuOptions() {

            var add = [];
            if (this.tablePreference.changed[this.columns_list] == true) {
                if (this.tablePreference.use[this.columns_list] != 0 && this.tablePreference.use[this.columns_list] != '+') {
                    var index = this.tablePreference.preferences[this.columns_list].findIndex(item => item.id == this.tablePreference.use[this.columns_list]);
                    if (index >= 0 && (this.tablePreference.preferences[this.columns_list][index].global == false || this.tablePreference.preferences[this.columns_list][index].user_id == this.user.id)) {

                        add.push({
                            key: "save",
                            disabled: (this.tablePreference.use[this.columns_list] == "+") ? true : false,
                            loading: false,
                            icon: "fas fa-floppy-disk",
                            text: this.__('labels.standard_table.save'),
                        });
                    }
                }
                add.push({
                    key: "savenew",
                    disabled: false,
                    loading: false,
                    icon: "fas fa-floppy-disk",
                    text: this.__('labels.standard_table.save_as_new'),
                })
            }
            if (this.tablePreference.use[this.columns_list] != 0 && this.tablePreference.use[this.columns_list] != '+') {
                var index = this.tablePreference.preferences[this.columns_list].findIndex(item => item.id == this.tablePreference.use[this.columns_list]);
                if (index >= 0 && (this.tablePreference.preferences[this.columns_list][index].global == false || this.tablePreference.preferences[this.columns_list][index].user_id == this.user.id)) {

                    add.push({
                        key: "remove",
                        disabled: (this.tablePreference.use[this.columns_list] == "+") ? true : false,
                        loading: false,
                        icon: "fas fa-trash",
                        text: this.__('labels.standard_table.remove'),
                    });
                }
            }

            return [
                {
                    key: "menuedit",
                    disabled: false,
                    loading: false,
                    icon: (this.layoutEdit == true) ? "fas fa-times" : "fas fa-pencil",
                    text: this.__('labels.standard_table.edit'),
                },
                {
                    key: "hidesearch",
                    disabled: false,
                    loading: false,
                    icon: (this.hideSearch == true) ? "fa fa-magnifying-glass-plus" : "fas fa-magnifying-glass-minus",
                    text: this.__('labels.standard_table.hide_search'),
                },
                ...add,

            ];
        },
        headerEditOptions() {
            return [
                // Haben noch keine FUnktion wäre auch deutlich schöner über drag & drop
                // {
                //     'key' : "moveleft",
                //     "text" : "Move Left",
                //     icon : "fas fa-arrow-left",
                // },
                // {
                //     'key' : "moveright",
                //     "text" : "Move Right",
                //     icon : "fas fa-arrow-right",
                // },
                {
                    'key': "remove",
                    "text": "Delete",
                    icon: "fas fa-trash",
                },
            ]
        },
        selectOptions() {
            var options = [];
            options.push({
                name: "Standard",
                value: 0,
            });
            if (this.possiblePreferences) {
                for (let i in this.possiblePreferences) {
                    options.push({
                        name: this.possiblePreferences[i].name,
                        value: this.possiblePreferences[i].id,
                    });
                }
            }
            if (this.tablePreference.use[this.columns_list] == "+") {
                options.push({
                    name: "New",
                    value: "+",
                });
            }
            return options;
        },
        useColumns:{
            get(){
                let tmp = [];
                if (this.columns_list) {
                    tmp = this.tablePreference.getColumnsForIdent(this.columns_list, this.preference_id);
                }
                if (this.columns) {
                 tmp = this.columns;
                }
                if(tmp && !this.currentUser.debugs.global){
                    return tmp.filter(item => !('display' in item) || item.display == true).filter(item => !('can' in item) || this.can(item.can));
                }
                if(tmp){
                    return tmp.filter(item => !('can' in item) || this.can(item.can));
                }
                    return tmp;
                },
            set(value) {
                console.log("set columsn", value);
            }
        },
        unusedColumns() {
            var unused = [];
            if (this.columns_list) {
                for (let i in this.tablePreference.columns[this.columns_list]) {

                    var index = this.useColumns.findIndex(item => item.id == this.tablePreference.columns[this.columns_list][i].id)
                    if (index > -1) {
                        // nothing
                    } else {
                        unused.push({
                            key: "add",
                            text: this.__(this.pretranslate + this.tablePreference.columns[this.columns_list][i].label),
                            data: this.tablePreference.columns[this.columns_list][i].id,
                            id: this.tablePreference.columns[this.columns_list][i].id,
                        })
                    }
                }
            }
            return unused;
        },
        possiblePreferences() {
            var tmp = this.tablePreference.listPreferences(this.columns_list);
            if (this.searchPreferences != "") {
                tmp.filter(item => item.name.indexOf(this.searchPreferences) >= 0)
            }
            return tmp;
        },
        componentName() {
            return "StandardTable";
        },
        filteredErrors() {
            return this.errors.filter(item => item != undefined);
        },
        showActionColumn() {

            if (typeof (this.isEditable) == "function" || this.isEditable == true || this.isDeleteable == true || this.isDuplicateable == true
                || (this.menuOptions !== undefined && Object.keys(this.menuOptions).length > 0)
            ) {
                return true;
            }

            return false;
        },
        locale() {
            const languageStore = useLanguageStore();
            return languageStore.locale;
        },
        columnCount() {
            var add = 0;
            var count = this.useColumns.length + add;
            if (this.isCheckable == true) {
                add++;
            }
            if (this.isExtendable == true) {
                add++;
            }
            if (this.showActionColumn) {
                add++;
            }
            return (count + add);
        },
        lodash() {
            return _;
        },
        isEmpty() {
            return (this.dataset && this.dataset.length > 0) ? false : true;
        },
        predefinedStyleTable: function () {
            if (this.predefinedStyle !== undefined && this.predefinedStyles[this.predefinedStyle] !== undefined) {
                return this.predefinedStyles[this.predefinedStyle].table;
            }
        },
        predefinedStyleThead: function () {
            if (this.predefinedStyle !== undefined && this.predefinedStyles[this.predefinedStyle] !== undefined) {
                return this.predefinedStyles[this.predefinedStyle].thead;
            }
        },
        predefinedStyleTh: function () {
            if (this.predefinedStyle !== undefined && this.predefinedStyles[this.predefinedStyle] !== undefined) {
                return this.predefinedStyles[this.predefinedStyle].th;
            }
        },
        predefinedStyleTbody: function () {
            if (this.predefinedStyle !== undefined && this.predefinedStyles[this.predefinedStyle] !== undefined) {
                return this.predefinedStyles[this.predefinedStyle].tbody;
            }
        },
        predefinedStyleTr: function () {
            if (this.predefinedStyle !== undefined && this.predefinedStyles[this.predefinedStyle] !== undefined) {
                return this.predefinedStyles[this.predefinedStyle].tr;
            }
        },
        predefinedStyleTd: function () {
            if (this.predefinedStyle !== undefined && this.predefinedStyles[this.predefinedStyle] !== undefined) {
                return this.predefinedStyles[this.predefinedStyle].td;
            }
        },
        predefinedStyleTotalTd: function () {
            if (this.predefinedStyle !== undefined && this.predefinedStyles[this.predefinedStyle] !== undefined) {
                return this.predefinedStyles[this.predefinedStyle].total_td ?? this.predefinedStyles[this.predefinedStyle].total_td;
            }
        },
        locale() {
            const languageStore = useLanguageStore();
            return languageStore.locale;
        }
    }
}
</script>
<style scoped>

.animate_moving {
    animation: LoadingAnimation 4s;
    animation-iteration-count: infinite;
}

@keyframes LoadingAnimation {
    0%   {
        /* opacity: 50%; */
        left: 0px;
    }

    50% {
        left: calc(100% - 8rem);
    }
    99% {
        left: 0px;
    }
}

</style>
